export default "__VITE_ASSET__CFumWVAa__"